
/*
type (string): The type of node (tag, text, style etc)
name (string): The name of the node
children (array): Array of children nodes
next (node): The node's next sibling
prev (node): The node's previous sibling
parent (node): The node's parent
data

*/

const htmlParserTransform = (node) => {

  if (node.type === 'script') {
    return <></>;
  }
  if (node.type === 'tag') {
    Object.keys(node.attribs).forEach(attrName => {
      if (attrName.startsWith('on')) {
        delete node.attribs[attrName];
      }

      if (attrName === 'href' || attrName === 'src') {
        try {
          const url = new URL(node.attribs[attrName]);
          if (url.protocol === 'javascript:') {
            node.attribs[attrName] = '#';
          }
        } catch {
          //
        }
      }
    });
  }
};

export default htmlParserTransform;